<template>
  <div id="app">
    <transition name="move" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    document.title = this.$route.meta.title
  },
  watch: {
    $route(val) {
      document.title = val.meta.title;
    }
  },
}
</script>

<style lang="scss">
@import url(https://fonts.googleapis.com/css?family=Montserrat:400,500,80);
#app {
  font-family: 'Montserrat', sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/App.vue